<div
	*ngIf="IS_NOT_NULL_OR_UNDEFINED(projectCarrierMapList) && projectCarrierMapList.length > 0"
	fxLayout="row"
	fxLayoutAlign="top left"
>
	<mat-accordion fxFlex="100">
		<mat-expansion-panel
			(closed)="matchClosed()"
			(opened)="setStep(cIndex)"
			*ngFor="let projectCarrierMap of projectCarrierMapList; let cIndex = index"
			[expanded]="step == cIndex"
			[hideToggle]="true"
			[ngClass]="{
				'mat-elevation-z4 primary-border': selectedMatch?.id == projectCarrierMap.id,
				'panel-selected mat-elevation-z4':
					selectedProjectCarrierMapIDs.indexOf(projectCarrierMap.id) > -1
			}"
			[ngStyle]="{ 'margin-top': cIndex && cIndex > 0 ? '1rem' : 0 }"
			class="custom-panel mat-elevation-z1"
			id="procuredCarriers"
		>
			<mat-expansion-panel-header
				(click)="emitPanelClickedEvent(projectCarrierMap, $event)"
				(keydown.arrowdown)="$event.stopImmediatePropagation()"
				(keydown.arrowup)="$event.stopImmediatePropagation()"
				(keydown.enter)="$event.stopImmediatePropagation()"
				[collapsedHeight]="'125px'"
				[expandedHeight]="'125px'"
				[dragData]="projectCarrierMap"
				dragImage="assets/icons/drag_indicator.svg"
				(dragend)="dragend()"
				(dragstart)="drag($event, projectCarrierMap)"
				dragTransitClass="no-border"
				draggable
				id="{{ projectCarrierMap.carrier.id }}"
			>
				<table class="full-width" fxFlex="100">
					<tr fxLayout="row">
						<td #businessNameContainer fxFlex fxLayout="row" fxLayoutAlign="start center">
							<div
								[ngStyle]="{
									'max-width':
										'calc(' +
										(businessNameContainer?.offsetWidth
											? businessNameContainer.offsetWidth -
											  (20 +
													(projectCarrierMap.carrierLastOpenedEmailAt ? 100 : 8) +
													(IS_NOT_NULL_OR_UNDEFINED(projectCarrierMap.carrier.active) &&
													!projectCarrierMap.carrier.active
														? 160
														: 8))
											: 230) +
										'px)'
								}"
								class="ellipsis"
							>
								<b *ngIf="projectCarrierMap.carrier.customerCarrier" class="font-size-16">
									{{ projectCarrierMap.carrier.businessName }}
								</b>
								<span *ngIf="!projectCarrierMap.carrier.customerCarrier" class="font-size-16">
									{{ projectCarrierMap.carrier.businessName }}
								</span>
							</div>
							<img
								*ngIf="projectCarrierMap.carrier.customerCarrier"
								class="in-network"
								height="18px"
								src="./assets/icons/network.svg"
							/>
							<span
								*ngIf="IS_NOT_NULL_OR_UNDEFINED(projectCarrierMap.carrierLastOpenedEmailAt)"
								class="font-size-16"
							>
								(RFP Viewed)
							</span>
							<div
								*ngIf="
									IS_NOT_NULL_OR_UNDEFINED(projectCarrierMap.carrier.active) &&
									!projectCarrierMap.carrier.active
								"
								class="font-size-12"
							>
								Carrier not authorized.
							</div>
						</td>

						<td fxFlex="20" fxLayoutAlign="start start">
							<div (click)="$event.stopPropagation()" fxLayoutAlign="start center">
								<span
									#mcDotContainer
									*ngIf="
										IS_NOT_EMPTY(projectCarrierMap.carrier.dot) ||
										IS_NOT_EMPTY(projectCarrierMap.carrier.mc)
									"
									class="font-size-14"
								>
									<span
										(click)="
											utilService.copyToClipboard(
												projectCarrierMap.carrier.mc,
												COPY_TO_CLIPBOARD_MSGS.MC
											)
										"
										*ngIf="IS_NOT_EMPTY(projectCarrierMap.carrier.mc)"
									>
										MC: {{ projectCarrierMap.carrier.mc }}
									</span>
									{{
										IS_NOT_EMPTY(projectCarrierMap.carrier.dot) &&
										IS_NOT_EMPTY(projectCarrierMap.carrier.mc)
											? ' / '
											: ''
									}}
									<span
										(click)="
											utilService.copyToClipboard(
												projectCarrierMap.carrier.dot,
												COPY_TO_CLIPBOARD_MSGS.DOT
											)
										"
										*ngIf="IS_NOT_EMPTY(projectCarrierMap.carrier.dot)"
									>
										DOT: {{ projectCarrierMap.carrier.dot }}
									</span>
								</span>
							</div>
						</td>

						<td fxFlex="21" fxLayoutAlign="start center">
							<div
								class="full-width"
								*ngIf="
									productsService.ASSIGN_CARRIERS &&
									IS_NOT_NULL_OR_UNDEFINED(usersList) &&
									usersList.length > 0 &&
									IS_NOT_NULL_OR_UNDEFINED(userCarrierMapList)
								"
							>
								<app-user-selector
									(userChanged)="setAssignee($event, projectCarrierMap.carrier.id)"
									[selectedUsers]="
										IS_NULL_OR_UNDEFINED(userCarrierMap[projectCarrierMap.carrier.id])
											? []
											: [getUserIdAssigned(projectCarrierMap.carrier.id)]
									"
									[showAssignMe]="false"
									[singleselect]="true"
									[usersList]="usersList"
									customCssClass="custom-form-field assignn_rep_max_width"
									floatLabel="never"
									fxFlex
									placeholder="Assign Rep"
								></app-user-selector>
							</div>
						</td>

						<td fxFlex="16" fxLayoutAlign="start center">
							<div>
								Authority:
								{{
									projectCarrierMap.carrier.authorityGrantDate
										? DATE_MDY(projectCarrierMap.carrier.authorityGrantDate)
										: 'N/A'
								}}
							</div>
						</td>

						<td fxFlex="11" fxLayoutAlign="end start">
							<span *ngIf="projectCarrierMap.matchScore; else na">
								<meter
									high="66"
									low="33"
									max="100"
									min="0"
									optimum="90"
									value="{{ projectCarrierMap.matchScore }}"
								></meter>
								<span> &nbsp;{{ projectCarrierMap.matchScore }} </span>
							</span>
							<span
								(click)="$event.stopPropagation(); emitPanelClickedEvent(projectCarrierMap, $event)"
								class="project-details-selection"
								matTooltip
							>
								<mat-icon>check_circle</mat-icon>
							</span>
						</td>
					</tr>

					<tr class="font-size-14 mt-3" fxLayout="row">
						<td fxFlex>
							<div
								*ngIf="
									IS_NOT_EMPTY(projectCarrierMap.carrier.city) ||
									IS_NOT_EMPTY(projectCarrierMap.carrier.state)
								"
							>
								HQ:&nbsp;
								<span *ngIf="IS_NOT_EMPTY(projectCarrierMap.carrier.city)">
									{{ projectCarrierMap.carrier.city
									}}{{ IS_NOT_EMPTY(projectCarrierMap.carrier.state) ? ',' : '' }}
								</span>
								<span *ngIf="IS_NOT_EMPTY(projectCarrierMap.carrier.state)">
									{{ projectCarrierMap.carrier.state }}
								</span>
							</div>
						</td>
						<td fxFlex="20" fxLayoutAlign="start center">
							<div class="full-width" fxLayoutAlign="start center">
								<span>PU: {{ projectCarrierMap.carrier.powerUnits }}</span>
								<span>&nbsp; / &nbsp;</span>
								<span>T: {{ projectCarrierMap.carrier.trailers }}</span>
								<span>&nbsp; / &nbsp;</span>
								<span>D: {{ projectCarrierMap.carrier.drivers }}</span>
							</div>
						</td>
						<td fxFlex="21" fxLayoutAlign="start center">
							<div class="full-width">
								Last Contact:
								{{
									IS_NOT_NULL_OR_UNDEFINED(projectCarrierMap.recentFeedbackDate)
										? (projectCarrierMap.recentFeedbackDate | date : 'MM/dd/yyy')
										: 'N/A'
								}}
							</div>
						</td>
						<td fxFlex="16" fxLayoutAlign="start center">
							<div class="full-width">
								<span>Insurance: </span>
								<span *ngIf="projectCarrierMap.carrier.bipdInsuranceAmount">
									{{
										projectCarrierMap.carrier.bipdInsuranceAmount
											| currency : 'USD' : 'symbol' : '1.0-0'
									}}
								</span>
								<span *ngIf="!projectCarrierMap.carrier.bipdInsuranceAmount">N/A</span>
							</div>
						</td>

						<td fxFlex="11" fxLayoutAlign="end end">
							<div
								(click)="
									$event.stopPropagation(); emitOpenFullProfileEventEvent(projectCarrierMap, $event)
								"
								*ngIf="IS_NOT_NULL_OR_UNDEFINED(projectCarrierMap.laneCount)"
								fxLayoutAlign="end center"
							>
								{{
									projectCarrierMap.laneCount +
										' Lane' +
										(projectCarrierMap.laneCount > 1 ? 's' : '')
								}}
								<img class="ml-4" height="18px" src="./assets/icons/road.svg" />
							</div>
						</td>
					</tr>

					<tr class="font-size-14 mt-3" fxLayout="row">
						<td fxFlex>
							<div class="full-width">
								<span>Lane:</span>
								<span *ngIf="projectCarrierMap.lanePath; else na">
									{{ projectCarrierMap.lanePath }}
								</span>
							</div>
						</td>
						<td fxFlex="20" fxLayoutAlign="start center">
							<div class="full-width">
								<span> Frequency: </span>
								<span *ngIf="projectCarrierMap.frequency; else na">
									{{ projectCarrierMap.frequency }}
									{{
										!utilService.isNullOrUndefined(projectCarrierMap.frequency) &&
										isFrequencyValidNumber(projectCarrierMap.frequency)
											? '/ weekly'
											: ''
									}}
								</span>
							</div>
						</td>
						<td fxFlex="21" fxLayoutAlign="start center">
							<div class="full-width">
								<span>Offered Rate:</span>
								<span
									*ngIf="IS_NOT_NULL_OR_UNDEFINED(projectCarrierMap.desiredPrice)"
									class="font-size-14"
								>
									{{ projectCarrierMap.desiredPrice / 100 | currency : 'USD' : 'symbol' : '1.0-2' }}
								</span>
								<span
									*ngIf="IS_NULL_OR_UNDEFINED(projectCarrierMap.desiredPrice)"
									class="font-size-14"
								>
									N/A
								</span>
							</div>
						</td>
						<td fxFlex="16" fxLayoutAlign="start center"></td>
						<td fxFlex="11" fxLayoutAlign="end center">
							<div (click)="$event.stopPropagation()">
								<div
									*ngIf="IS_NOT_NULL_OR_UNDEFINED(projectCarrierMap.notesCount)"
									fxLayoutAlign="end center"
								>
									{{
										projectCarrierMap.notesCount +
											' Note' +
											(projectCarrierMap.notesCount > 1 ? 's' : '')
									}}
									<img class="ml-4 px-2" height="18px" src="./assets/icons/sticky-note.svg" />
								</div>
							</div>
						</td>
					</tr>

					<tr class="font-size-14 mt-3" fxLayout="row">
						<td fxFlex>
							<div class="full-width">
								<span>Contacts:</span>
								<span *ngIf="IS_NOT_NULL_OR_UNDEFINED(projectCarrierMap.carrier.contacts)">
									{{ projectCarrierMap.carrier.contacts.length }}
								</span>
							</div>
						</td>
						<td fxFlex="20" fxLayoutAlign="start center">
							<span>DH-O:</span>
							<span *ngIf="IS_NOT_NULL_OR_UNDEFINED(projectCarrierMap.originDeadhead); else na">
								{{ projectCarrierMap.originDeadhead | number : '1.0-0' }}
							</span>
							<span class="m-l-1">DH-D:</span>
							<span
								*ngIf="IS_NOT_NULL_OR_UNDEFINED(projectCarrierMap.destinationDeadhead); else na"
							>
								{{ projectCarrierMap.destinationDeadhead | number : '1.0-0' }}
							</span>
						</td>
						<td fxFlex="21" fxLayoutAlign="start center">
							<div class="full-width">
								<span>Last Load:</span>
								<span *ngIf="accountCarrierLanes[projectCarrierMap.carrier.id]?.rateUpdatedAt">
									{{
										accountCarrierLanes[projectCarrierMap.carrier.id]?.rateUpdatedAt
											| date : 'MM/dd/yyyy'
									}}
								</span>
								<span *ngIf="!accountCarrierLanes[projectCarrierMap.carrier.id]?.rateUpdatedAt">
									N/A
								</span>
							</div>
						</td>
						<td fxFlex="16" fxLayoutAlign="start center"></td>
						<td fxFlex="11" fxLayoutAlign="end center">
							<span *ngIf="projectCarrierMap.projectsList">
								<span
									*ngIf="projectCarrierMap.projectsList?.length > 0"
									class="dropdown"
									fxLayoutAlign="center center"
								>
									{{ projectCarrierMap.projectsList.length }}
									{{ projectCarrierMap.projectsList.length > 1 ? 'Projects' : 'Project' }}
									<mat-icon class="font-size-18 h-18 ml-4 pl-2 w-inherit">assignment</mat-icon>
								</span>

								<span
									*ngIf="projectCarrierMap.projectsList.length == 0"
									fxLayoutAlign="center center"
								>
									<span class="primary-text">No Projects</span>
								</span>
							</span>
						</td>
					</tr>
				</table>
			</mat-expansion-panel-header>
			<div fxLayout="row">
				<div fxFlex fxLayoutAlign="end end">
					<a
						(click)="emitOpenFullProfileEventEvent(projectCarrierMap, $event)"
						class="cursor-pointer"
					>
						<span class="primary-text m-r-1 p-r-0-5"><u>Full Profile</u></span>
					</a>
				</div>
			</div>
			<div
				*ngIf="
					accountSettings.IS_FEEDBACK_ENABLED &&
					USER_ACCOUNT_TYPE != ACCOUNT_TYPE.ADMIN &&
					accountId &&
					step == cIndex
				"
				class="p-l-1 p-r-1"
			>
				<app-carrier-feedbacks [accountId]="accountId" [carrierId]="projectCarrierMap.carrier.id">
				</app-carrier-feedbacks>
			</div>
			<div
				*ngIf="
					(!isContactsListInProgress && contactList?.length > 0) ||
					IS_NULL_OR_UNDEFINED(contactList)
				"
				class="p-l-1 p-r-1"
				fxLayout="row"
			>
				<h3 class="primary-text" fxFlex>Representatives</h3>
			</div>

			<div
				*ngIf="
					(!isContactsListInProgress && contactList?.length > 0) ||
					IS_NULL_OR_UNDEFINED(contactList)
				"
				class="p-l-1 p-r-1 p-b-1"
			>
				<app-carrier-contacts
					(updateContactsList)="updateContactsList($event)"
					[carrierId]="projectCarrierMap.carrier.id"
					[carrier]="null"
					[contactList]="contactList"
					[editPrimaryContact]="false"
					[isCarrierProfile]="true"
					[isEditContact]="true"
					[oldCarrierId]="null"
				>
				</app-carrier-contacts>
			</div>
		</mat-expansion-panel>
	</mat-accordion>
</div>

<ng-template #na>
	<span> N/A </span>
</ng-template>
